module.exports = __webpack_public_path__ + "img/多氟多.d11311a3.png";